import LoginView from './views/LoginView.vue';

const authRoutes = [
    {
        path: '/',
        name: 'Login',
        component: LoginView,
        meta: {
            title: 'Login',
            requiresAuth: false,
        }
    }
]

export default authRoutes;